import gql from 'graphql-tag';

export const refundTransactionMutation = gql`
  mutation refundTransaction(
    $refundTransactionRequest: RefundTransactionRequest!
  ) {
    accounts {
      refundTransaction(refundTransactionRequest: $refundTransactionRequest) {
        transactionId
      }
    }
  }
`;
